import { useDispatch, useSelector } from 'react-redux'
import { useCallback, useState } from 'react'
import { useBranchOfficeMemberAddDialog } from '../../../hooks/useDialog'
import { CompanyActions } from '../../../store/company'
import Dialog from '../../atoms/feedback/Dialog'
import { FlexColumn, FlexRow } from '../../atoms/layout/Flex'
import Button from '../../atoms/inputs/Button'
import FormItem from '../../molecules/inputs/FormItem'
import { CompanySelectors } from '../../../store/company/selectors'
import SelectString from '../../atoms/inputs/SelectString'

export default function BranchOfficeMemberAddDialog() {
  const { state, close } = useBranchOfficeMemberAddDialog()
  const dispatch = useDispatch()
  const [userId, setUserId] = useState<string>()
  const users = useSelector(CompanySelectors.users)

  const handleAdd = useCallback(() => {
    if (state?.branchOffice && userId) {
      dispatch(CompanyActions.addBranchOfficeMember({ branchOfficeId: state.branchOffice.id, userId }))
    }
  }, [dispatch, state?.branchOffice, userId])

  return (
    <Dialog
      open={state !== undefined}
      onClose={close}
      title="支店メンバーの追加"
      actions={
        <FlexRow>
          <Button onClick={handleAdd}>追加</Button>
        </FlexRow>
      }
    >
      <FlexColumn>
        <FormItem label="追加するユーザー">
          <SelectString
            value={userId}
            items={users.map((user) => ({
              label: user.name,
              value: user.id,
            }))}
            onChange={setUserId}
          />
        </FormItem>
      </FlexColumn>
    </Dialog>
  )
}
